import React, { useState } from "react";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import ProfileImagePopup from "./ProfileImagePopup";
import {
  AdminPanelTitle,
  AdminMetric,
  AdminMainText,
  AdminSupportingText,
  AdminMetadataText,
} from "../../sections/AdminDashboard/shared/adminUx";

const ProfileImageWidget = ({ errors }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const fields = [
    { name: "Profile picture", key: "profilePicture", estimatedTime: "2 min", required: false },
  ];

  const [completionState, setCompletionState] = useState({
    profilePicture: null,
  });

  const displayValues = {
    profilePicture: completionState.profilePicture,
  };

  const calculateProgress = () => {
    const completedFields = fields.filter((field) => {
      const hasValue = displayValues[field.key] && displayValues[field.key] !== null;
      return hasValue;
    }).length;
    return Math.round((completedFields / fields.length) * 100);
  };

  const progress = calculateProgress();

  const getFileName = (file) => {
    if (!file) return "";
    return file.name || "Uploaded";
  };

  return (
    <>
      <DashboardMainContainer className="masonry-item w-[500px] h-auto account-widget">
        <div className="flex items-center justify-between py-3 px-4 border-b border-mediumgray">
          <AdminPanelTitle className="text-offblack">Profile Image</AdminPanelTitle>
          <div className="flex items-center gap-2">
            <div className="w-16 h-1.5 bg-lightgray rounded-full overflow-hidden">
              <div
                className="h-full bg-freshgreen transition-all duration-500 ease-out"
                style={{ width: `${progress}%` }}
              />
            </div>
            <AdminMetric size="micro" className="text-offblack tabular-nums">
              {progress}%
            </AdminMetric>
          </div>
        </div>

        <div className="px-4 py-4">
          <div className="space-y-0">
            {fields.map((field) => {
              const isCompleted =
                displayValues[field.key] && displayValues[field.key] !== null;

              return (
                <div key={field.key} className="flex items-center justify-between">
                  {progress === 100 ? (
                    <div
                      className="group flex items-center w-full py-[4px] cursor-pointer hover:text-primaryblue rounded px-2 -mx-2"
                      onClick={() => setIsPopupOpen(true)}
                    >
                      <AdminSupportingText className="w-40 shrink-0 text-offblack group-hover:text-primaryblue">
                        {field.name}
                      </AdminSupportingText>
                      <AdminMainText className="text-offblack group-hover:text-primaryblue truncate">
                        {isCompleted ? getFileName(displayValues[field.key]) : `Estimated ${field.estimatedTime}`}
                      </AdminMainText>
                    </div>
                  ) : (
                    <>
                      <div
                        className="group flex items-center py-[4px] cursor-pointer hover:text-primaryblue rounded px-2 -mx-2 flex-1"
                        onClick={() => setIsPopupOpen(true)}
                      >
                        <div
                          className={`w-2 h-2 rounded-full mr-3 ${isCompleted ? "bg-freshgreen" : "bg-mediumgray"}`}
                        />
                        <AdminSupportingText
                          className={`w-40 shrink-0 ${isCompleted ? "text-offblack group-hover:text-primaryblue" : "text-mediumgray group-hover:text-primaryblue"}`}
                        >
                          {field.name}
                        </AdminSupportingText>
                        <AdminMainText className="text-offblack group-hover:text-primaryblue truncate max-w-[200px]">
                          {isCompleted ? getFileName(displayValues[field.key]) : ""}
                        </AdminMainText>
                      </div>
                      <AdminMetadataText className="text-mediumgray">
                        {isCompleted ? "Completed" : "Start"}
                      </AdminMetadataText>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </DashboardMainContainer>

      {isPopupOpen && (
        <ProfileImagePopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          errors={errors}
          onCompletionUpdate={(fieldKey, value) => {
            setCompletionState((prev) => ({
              ...prev,
              [fieldKey]: value,
            }));
          }}
        />
      )}
    </>
  );
};

export default ProfileImageWidget;
